import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const FETCH_CLIENT_REPORT_TEMPLATE_NAME = gql`
  query fetchClientReportTemplateName($id: ObjectID!) {
    fetchClientReportTemplate(clientReportTemplateId: $id) {
      clientReportTemplate {
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;

export function ClientReportTemplateBreadcrumb(): string {
  const { id } = useParams();
  const { data } = useQuery(FETCH_CLIENT_REPORT_TEMPLATE_NAME, {
    variables: { id: id! },
    skip: !id,
  });
  const { t } = useTranslation();
  const templateName = data?.fetchClientReportTemplate?.clientReportTemplate
    ? translateBackend(
        data.fetchClientReportTemplate.clientReportTemplate.translatedName,
      )
    : '';

  return t('clientReportTemplate:nameTemplate', { name: templateName });
}
